import {
  Chip,
  Divider,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAlert } from "../../../Contexts/AlertContext/AlertService";
import { useLoading } from "../../../providers/loadingProvider";
import { useNotify } from "../../../providers/NotificationProvider";
import {
  advisorSelector,
  committeeSelector,
} from "../../../store/advisorSlice";
import ProposalAdvisor from "../Components/proposals/ProposalAdvisor";
import service from "../Helpers/gifservices";

const useStyles = makeStyles((theme) => ({
  select: {
    width: "75%",
  },
}));

export default function Proposals() {
  const classes = useStyles();
  const loading = useLoading();
  const notify = useNotify();
  const alert = useAlert();
  const committee = useSelector(committeeSelector);
  const advisor = useSelector(advisorSelector);
  const [show, setShow] = useState("All");
  const [showMember, setShowMember] = useState("All");
  const [proposals, setProposals] = useState([]);
  const [proposalsToShow, setProposalsToShow] = useState([]);
  const [advisors, setAdvisors] = useState([]);

  const AssignProposalToMe = async (proposalId) => {
    const loadingId = loading.addLoading("Assigning Proposal");
    const committeeId = committee.committeeId;
    const result = await service.AssotiateMeToProposal({
      proposalId,
      committeeId,
    });
    loading.removeLoading(loadingId);
    if (!result) {
      await alert({
        title: "Error Assigning",
        description: `Sorry there was a problem in assigning to the Propsal`,
      });
    } else {
      notify.show("Assigning completed successfully");
      getProposals();
    }
  };

  const getProposals = useCallback(async () => {
    if (!committee) return;
    const loadingId = loading.addLoading("Loading Proposals");
    const committeeId = committee.committeeId;
    const proposals = await service.GetCommitteeProposals({ committeeId });
    proposals.sort(
      (a, b) => Number(a.proposalFinalRank) - Number(b.proposalFinalRank)
    );
    setProposals(proposals);
    loading.removeLoading(loadingId);
  }, [committee, loading]);

  const getAdvisorTotalProposalNumber = (advisorId) => {
    return proposals
      .filter((p) => p.proposalAdvisors.length > 0)
      .filter((p) => p.proposalAdvisors[0].advisorId === advisorId).length;
  };

  const getAdvisors = useCallback(async () => {
    if (!committee) return;
    const committeeId = committee.committeeId;
    const advisors = await service.GetCommitteeAdvisors({ committeeId });
    setAdvisors(advisors);
  }, [committee]);

  useEffect(() => {
    getProposals();
    getAdvisors();
  }, [getProposals, getAdvisors]);

  useEffect(() => {
    const advisorId = advisor.id;
    let proposalsToShow = proposals;
    if (show === "Assigned to me")
      proposalsToShow = proposalsToShow
        .filter((p) => p.proposalAdvisors.length > 0)
        .filter((p) => p.proposalAdvisors[0].advisorId === advisorId);
    if (show === "Not Assigned")
      proposalsToShow = proposalsToShow.filter(
        (p) => p.proposalAdvisors.length === 0
      );
    if (show === "By Committee member") return;

    setProposalsToShow(proposalsToShow);
  }, [show, advisor, proposals]);

  useEffect(() => {
    if (show !== "By Committee member") return;
    let proposalsToShow = proposals;
    if (showMember !== "All") {
      proposalsToShow = proposalsToShow
        .filter((p) => p.proposalAdvisors.length > 0)
        .filter((p) => p.proposalAdvisors[0].advisorId === showMember);
    }
    setProposalsToShow(proposalsToShow);
  }, [showMember, show, proposals]);

  return (
    <>
      <Grid container>
        <Grid item xs={4}>
          <Typography style={{ fontWeight: 500, marginBottom: 3 }}>
            Show
          </Typography>
          <Select
            className={classes.select}
            label={"show"}
            value={show}
            onChange={(e) => setShow(e.target.value)}
          >
            <MenuItem value={"All"}>All</MenuItem>
            <MenuItem value={"Assigned to me"}>Assigned to me</MenuItem>
            <MenuItem value={"Not Assigned"}>Not Assigned</MenuItem>
            <MenuItem value={"By Committee member"}>
              By Committee member
            </MenuItem>
          </Select>
        </Grid>
        {show === "By Committee member" && (
          <Grid item xs={4}>
            <Typography style={{ fontWeight: 500, marginBottom: 3 }}>
              Committee member
            </Typography>
            <Select
              className={classes.select}
              value={showMember}
              onChange={(e) => setShowMember(e.target.value)}
            >
              <MenuItem value={"All"}>All</MenuItem>
              {advisors.map((advisor) => (
                <MenuItem key={advisor.advisorID} value={advisor.advisorID}>
                  {advisor.advisorName}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        )}
      </Grid>
      {proposalsToShow.map((proposal) => (
        <>
          <Divider>
            <Chip  label={<Typography variant="h6">{proposal.name}</Typography>} sx={{backgroundColor:"yellow"}}></Chip>
          </Divider>
          <ProposalAdvisor
            key={proposal.id}
            proposal={proposal}
            totalProposalsNumber={proposals.length}
            advisorTotalProposalNumber={getAdvisorTotalProposalNumber(
              proposal.proposalAdvisors[0]?.advisorId
            )}
            AssignProposalToMe={AssignProposalToMe}
            refreshProposals={getProposals}
          />
        </>
      ))}
    </>
  );
}
